import {lazy} from 'react';
import LazyComponent from 'components/LazyComponent';

export default [
  {
    component: LazyComponent(lazy(() => import('./Update'))),
    path: '/compliance/update/:id',
  },
];
